'use client'

import { Button } from '@/components/ui/button'
import type { LucideIcon } from 'lucide-react'

interface ToolbarButton {
  icon: LucideIcon
  onClick: () => void
  title: string
  disabled?: boolean
}

interface ToolbarButtonGroupProps {
  label: string
  buttons: ToolbarButton[]
}

export function ToolbarButtonGroup({ label, buttons }: ToolbarButtonGroupProps) {
  return (
    <div className='flex flex-col gap-2'>
      <p className='text-sm font-medium text-gray-700'>{label}</p>
      <div className='w-full flex flex-row gap-2'>
        {buttons.map((button) => {
          const IconComponent = button.icon
          return (
            <Button
              key={button.title}
              type='button'
              variant='ghost'
              size='icon'
              onClick={button.onClick}
              disabled={button.disabled}
              className='flex items-center justify-center bg-gray-100 hover:bg-gray-200'
              title={button.title}
            >
              <IconComponent className='h-5 w-5' />
            </Button>
          )
        })}
      </div>
    </div>
  )
}
